/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const DELETE_ACTION = gql`
  mutation DeleteAction($input: DeleteActionInput!) {
    deleteAction(data: $input)
  }
`
